import Api from './Api';
import pSBC from 'shade-blend-color';
import getCampaign from 'hooks/useCampaign';
import { rgbaToHex } from 'hex-and-rgba';
import Decimal from 'decimal.js';
import { log } from 'xstate/lib/actions';
import { API_GATEWAY_NEW } from 'aws-exports';
import Axios from 'axios';
// import ISO6391 from "iso-639-1";

export const get_product_by_handle = (shop_url, product_handle) =>
    Api.get(`https://${shop_url}/products/${product_handle}.json?fields=variants`);

export const getGoal = ({ oldGoal, specific_goals, byQuantity, inCents = false }) => {
    const cents = inCents ? 100 : 1;
    const rate = window.Shopify?.currency?.rate ?? 1;
    const multiplier = (value) =>
      value *
      (byQuantity || Number(rate) * cents);
    if (!specific_goals) return oldGoal ? multiplier(oldGoal) : 0;
    const goal = specific_goals.find(
        ({ currency }) => currency === window.Shopify.currency.active
    )?.goal;
    if (goal) return inCents ? goal * 100 : goal;
    return multiplier(specific_goals.find(({ main }) => main === true).goal);
};

const formHasFile = (formData, variant_id) => {
    let hasFile = false;

    if (!formData) {
        return false;
    }
    const entriesIsFunction = typeof formData.entries === 'function';

    const getEntries = () => (entriesIsFunction ? formData.entries() : formData.entries);
    for (const [name, type] of getEntries()) {
        if (type instanceof File) {
            hasFile = true;
            window.mu_form_files[variant_id] = [
                ...new Set(
                    (window.mu_form_files[variant_id] || []).concat([
                        name.replace('properties[', '').replace(']', '')
                    ])
                )
            ];
            // localStorage.setItem(
            //   "mu_form_files",
            //   JSON.stringify(window.mu_form_files)
            // );
        }
    }
    return hasFile;
};

export function getLangPath(path) {
    const { origin } = window.location;
    let langPath = '/';
    // const pathArray = window.location.pathname.replace(/^\//, "").split("/");
    if (window.Shopify?.routes?.root) {
        langPath = window.Shopify.routes.root;
    }
    // else if (pathArray.length && ISO6391.validate(pathArray[0])) {
    //   langPath = `/${pathArray[0]}/`;
    // }
    return `${origin}${langPath}${path}`;
}

export function GetCartLevelAutoDiscount({ cart_level_discount_applications = [] }, types = ['automatic', '']) {
    const discount = cart_level_discount_applications?.find((discount) =>{
        if(discount.discount_application){
            discount = discount.discount_application
        }
        const {type,total_allocated_amount} = discount
        return types.includes(type) && total_allocated_amount > 0
    });
    if(!discount) return  undefined
    return discount.discount_application || discount
}

export function GetDiscountFromCheckoutPage(serializedGraphqlString) {
    try {
        const ParsedGraphql = JSON.parse(serializedGraphqlString);
        for (let key in ParsedGraphql)
            if (ParsedGraphql[key]?.session?.negotiate?.result?.sellerProposal) {
                const result = ParsedGraphql[key].session.negotiate.result;
                const errorMessage =
                    ParsedGraphql[key].session.negotiate.errors.find(
                        (error) => 'DISCOUNTS_NOT_FOUND' === error.code
                    )?.localizedMessage || null;
                const { subtotalBeforeReductions, runningTotal, merchandiseDiscount } = result.sellerProposal;
                const discountCode = merchandiseDiscount?.lines[0]?.discount?.code;
                const OriginalTotal = new Decimal(subtotalBeforeReductions.value.amount)
                    .mul(100)
                    .toNumber();
                const NewTotal = new Decimal(runningTotal.value.amount).mul(100).toNumber();
                const discountValue = new Decimal(OriginalTotal).minus(NewTotal).toNumber();
                return {
                  errorMessage,
                  discountValue,
                  discountCode
                };
            }
    } catch (error) {
        console.log(error);
    }
}

export function CartHasAutoDiscount(cart) {
    const hasItemLevelAutoDiscount = cart.items.some(
        ({ discounts, line_level_discount_allocations }) => {
            const hasDiscount = !!discounts?.length;
            if (!hasDiscount) return false;
            const hasAutoDiscount = line_level_discount_allocations?.find(
                ({ discount_application }) => ['automatic', ''].includes(discount_application?.type)
            );
            return !!hasAutoDiscount;
        }
    );
    const hasCartLevelAutoDiscount = cart.cart_level_discount_applications?.some((discount) =>
        ['automatic', ''].includes(discount?.type)
    );
    return hasItemLevelAutoDiscount || hasCartLevelAutoDiscount;
}

export function getCartLink() {
    return getLangPath(window.mu_use_cart_json ? 'cart.json' : 'cart.js');
}

export const addToCart = (
    {
        variant_id,
        quantity,
        properties,
        selling_plan,
        currency,
        // props below are required for preview
        isPreview = false,
        shop_url = null,
        product_handle = null,
        product = null
    },
    formData
) => {
    if (Array.isArray(selling_plan)) {
        selling_plan = selling_plan[0];
    }
    else if (typeof selling_plan === 'string'){
        selling_plan = Number.isNaN(parseInt(selling_plan)) ? undefined : parseInt(selling_plan);
    }
    const hasFile = formHasFile(formData, variant_id);
    if (isPreview) {
        variant_id = parseVariantId(variant_id);
        if (product) {
            const { id, image, title: product_title, variants } = product;
            const variant = variants.find(({ id }) => id === variant_id);
            const price = parseFloat((parseFloat(variant.price) * 100).toFixed(0));
            return Promise.resolve({
                ...variant,
                price,
                product_title,
                product_id: parseInt(id),
                image,
                quantity
            });
        }
        return new Promise((resolve, reject) => {
            get_product_by_handle(shop_url, product_handle)
                .then(({ data }) => {
                    const { variants, title, images } = data.product;
                    const variant = variants.find(({ id }) => id === parseInt(variant_id));
                    const image = variant.image_id
                        ? images.find(({ id }) => variant.image_id).src
                        : data.product.image.src;
                    const price = parseFloat((parseFloat(variant.price) * 100).toFixed(0));
                    resolve({ ...variant, price, product_title: title, image, quantity });
                })
                .catch(reject);
        });
    } else {
        if (Array.isArray(variant_id)) {
            variant_id = variant_id.map(parseVariantId).filter((singleId) => !isNaN(singleId));
            if (variant_id.length == 1) variant_id = variant_id[0];

            if (variant_id.length == 0) return;
        }
        variant_id = parseVariantId(variant_id);
        return new Promise((resolve, reject) => {
            Api.post(
                getLangPath(`cart/add.js?m=true&shop=${window.Shopify.shop}`),
                hasFile
                    ? formData
                    : Array.isArray(variant_id)
                    ? {
                          items: variant_id.map((singleId) => ({
                              quantity,
                              id: parseVariantId(singleId)
                          }))
                      }
                    : {
                          quantity,
                          id: parseVariantId(variant_id),
                          properties,
                          selling_plan
                      }
            )
                .then(({ data }) => {
                    if (window.ttq && !window.mu_disable_tiktok_tracking) {
                        window.ttq.track('AddToCart', {
                            contents: [
                                {
                                    content_type: 'product',
                                    content_name: data.title,
                                    content_id: data.product_id,
                                    quantity: data.quantity,
                                    price: data.price / 100
                                }
                            ],
                            value: data.price / 100,
                            currency
                        });
                    }

                    Api.get(getCartLink()).then(({ data }) => {
                        resolve(data);
                    });
                })
                .catch(reject);
        });
    }
};

export const findItem = ({ line, items, variant_id }) => {
    return items.find(({ variant_id: id }, index) =>
        line ? line === index + 1 : id ? id.toString() == variant_id.toString() : false
    );
};

export const updateCartItem = ({
    variant_id,
    line,
    quantity,
    properties,
    selling_plan,
    isPreview = false,
    state = null
}) => {
    if (Array.isArray(selling_plan)) {
        selling_plan = selling_plan[0];
    }
    if (isPreview) {
        if (quantity === 0 && state.items.length === 1) {
            return Promise.resolve(state.items);
        }
        const stateCopy = { ...state };
        const newItems = stateCopy.items.map((item) => {
            if (item.id === variant_id) {
                return { ...item, quantity };
            }
            return item;
        });
        return Promise.resolve(newItems.filter(({ quantity }) => quantity > 0));
    } else {
        return new Promise((resolve, reject) => {
            Api.post(getLangPath(`cart/change.js?m=true&shop=${window.Shopify.shop}`), {
                quantity,
                properties,
                selling_plan,
                id: line ? undefined : parseVariantId(variant_id).toString(),
                line
            })
                .then(({ data }) => {
                    const { items, cart_level_discount_applications } = {
                      ...data,
                      items: data.items.map((item) => ({
                        ...item,
                        // price: item.line_price ? (item.line_price / item.quantity):item.price,
                        // original_price: item.original_line_price ? (item.original_line_price / item.quantity) : item.original_price
                      })),
                    };
                    resolve({ items, cart_level_discount_applications });
                })

                .catch(reject);
        });
    }
};

export const getBundleDiscount = ({ reward, type }, quantity, priceInCents, money_format) => {
    quantity = parseInt(quantity);
    reward = parseFloat(reward);

    let totalDiscount = 0;

    if (type === 'percentage') {
        const perUnitDiscount = Math.floor(priceInCents * (reward / 100));
        totalDiscount = perUnitDiscount * quantity;
    } else {
        totalDiscount = calculateDiscount({
            type,
            reward,
            total: priceInCents * quantity
        });
    }

    const total = priceInCents * quantity;
    const finalPrice = total - totalDiscount;

    return {
        plain: finalPrice,
        formatted: formatMoney(finalPrice, money_format),
        discounted: totalDiscount
    };
};


export const sortByProp = (prop, order = 'desc') => {
    return (array) => {
        return [...array].sort(function (a, b) {
            var x = a[prop];
            var y = b[prop];
            if (order === 'desc') {
                return x > y ? -1 : x < y ? 1 : 0;
            } else {
                return y > x ? -1 : y < x ? 1 : 0;
            }
        });
    };
};

export const sortByQuantity = sortByProp('quantity');

export const isMobile = () => {
    const a = navigator.userAgent || navigator.vendor || window.opera;
    return (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
        )
    );
};

export const calculateDiscount = ({ reward, type, total }) => {
    switch (type) {
        case 'fixed_amount':
            return Math.abs(reward) * 100 * Number(window.Shopify.currency.rate);
        case 'percentage':
            return Math.floor((total * Math.abs(reward)) / 100);
        default:
            return 0;
    }
};

export function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.', noMarketsRounding = false) {
    if (isNaN(number) || number == null) {
        return 0;
    }

    number = number / 100.0;
    if (window.mu_market_rounding && !noMarketsRounding) number = Math.ceil(number);
    number = number.toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
}

export const formatMoney = (n, money_format = '${{amount}}', formatter = formatWithDelimiters) => {
    const formattedMoney = money_format
    .replace(/{{\s*?amount\s*?}}/g, formatter(n, 2))
    .replace(/{{\s*?amount_with_decimal_separator\s*?}}/g, formatter(n, 2))
    .replace(/{{\s*?amount_no_decimals\s*?}}/g, formatter(n, 0))
    .replace(/{{\s*?amount_with_comma_separator\s*?}}/g, formatter(n, 2, '.', ','))
    .replace(/{{\s*?amount_no_decimals_with_comma_separator\s*?}}/g, formatter(n, 0, '.', ','))
    .replace(/{{\s*?amount_with_apostrophe_separator\s*? }}/g, formatter(n, 2, "'", '.'));
    return window.mu_after_format_money
      ? window.mu_after_format_money(formattedMoney)
      : formattedMoney;
}

export const logError = (error) => {
    //log errors to bugSnag
    console.log('Monster error:', error);
};

export function getVariantPrice({ isPreview, cart_currency, variant, plansData }) {
    if(plansData) {
        const selected_variant = plansData.variants?.find((v) => v.id === variant.id);
        if(selected_variant) {
            const subscription_first =
            selected_variant.requires_selling_plan || window.mu_fbt_sub_first;
            const { selling_plan_allocations } = selected_variant;
            const price = selling_plan_allocations?.[0]?.price;
            if (subscription_first && price) {
                return window.mu_market_rounding
                  ? Math.ceil(price / 100)
                  : price / 100;
            }
        }
    }
    const activeCurrency = isPreview ? cart_currency : window.Shopify.currency.active;
    const rate = isPreview || window.mu_stop_shopify_rate ? 1 : Number(window.Shopify.currency.rate);
    
    let unformattedPrice;

    const presentmentPrices = variant?.presentmentPrices || variant?.presentment_prices;

    if (Array.isArray(presentmentPrices)) {
        const foundPrice = presentmentPrices.find(
        ({ price }) => price.currency_code == activeCurrency
        );
        unformattedPrice = foundPrice ? Number(foundPrice.price.amount) : Number(variant.price) * rate;
    } else {
        unformattedPrice = presentmentPrices && presentmentPrices[activeCurrency]
        ? Number(presentmentPrices[activeCurrency].price)
        : Number(variant.price) * rate;
    }
    if (window.mu_stop_presentment) {
        unformattedPrice = Number(variant.price) * rate;
    } else {
        unformattedPrice = Number(unformattedPrice.toFixed(2));
    }
    
    return window.mu_market_rounding ? Math.ceil(unformattedPrice) : unformattedPrice;
}


export const getAddedGifts = ({ goal, productAddedToCart }) => {
    let { products, product } = goal.gift;
    if (!products) {
        products = product ? [{ variants: [{ id: product.variant_id }] }] : [];
    }
    return products
        .map(({ variants }) => variants)
        .flat()
        .filter((variant) => productAddedToCart(variant, true));
};

export const productHasOneVariant = (product) => {
    const { variants } = product;
    return variants.length === 1;
    // return options.every(({ values }) => values.length === 1);
};

export const variantIsOnStock = (variant) => {
    const { inventory_management, inventory_quantity, inventory_policy } = variant;
    return inventory_management && inventory_policy === 'deny' ? inventory_quantity >= 1 : true;
};

export const getMaxQuantity = (variant) => {
    const { inventory_management, inventory_quantity, inventory_policy } = variant;
    return inventory_management && inventory_policy === 'deny' ? inventory_quantity  : Infinity;
}

export const parseProductId = (string) => {
    // example gid://shopify/ProductVariant/19566771404862
    const pattern = new RegExp('gid://shopify/Product/([0-9]+)$');
    if (pattern.test(string)) return parseInt(string.match(pattern)[1]);  
    return string;
};

export const parseVariantId = (string) => {
    // example gid://shopify/ProductVariant/19566771404862
    const pattern = new RegExp('gid://shopify/ProductVariant/([0-9]+)$');
    if (pattern.test(string)) return parseInt(string.match(pattern)[1]);
    return string;
};

const add = (x, y) => x + y;

export const getTotal = (items, products=[]) => {
  const initialValue = window.mu_shipProtectSelected
    ? window.mu_shipProtectPrice
    : 0;
  // console.log(initialValue,  window.mu_shipProtectSelected , window.mu_shipProtectPrice);
  return items.length
    ? items
        .filter(
          ({ product_type, price }) =>
            !(
              ["free_gift", "singleton_gift"].includes(
                product_type?.toLowerCase()
              ) && price === 0
            )
        )
        .map(
          ({
            product_id,
            variant_id,
            price,
            quantity,
            selling_plan_allocation,
          }) => {
            const selectedProduct = products.find(({ id }) => id == product_id);
            const selectedVariant = selectedProduct?.variants?.find(
              ({ id }) => id == variant_id
            );

            const itemPrice =
              selectedVariant && !selling_plan_allocation
                ? Number(selectedVariant.price) * 100
                : price;

            return itemPrice * quantity;
          }
        )
        .reduce(add, initialValue)
    : initialValue;
};

export function sortBundles(bundles) {
    return [...bundles].sort((a, b) => a.quantity - b.quantity);
}
export function BundlesIndexMap(bundles) {
    return [...bundles].reduce((acc, cur, index) => {
        const { quantity } = cur;
        const next = bundles[index + 1];
        const quantityDeference = next ? next.quantity - quantity : 1;
        acc[quantity] = index;
        if (quantityDeference > 1) {
            for (let i = 1; i < quantityDeference; i++) {
                acc[quantity + i] = index;
            }
        }
        return acc;
    }, {});
}

export const extractContent = (s) => {
    var span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
};
export const getCompareAtDiscount = ({ filteredItems, compareAtMap, products }) => {
    const compareAtDiscount = [...filteredItems.filter((item) => !window.mu_exclude_free_gift_price || item.product_type != "free_gift")].reduce((acc, { product_id, variant_id, price, quantity }) => {
        const selectedVariant = products?.find(({ id }) => id == product_id)?.variants?.find(({ id }) => id == variant_id);
        let rate = window.mu_stop_shopify_rate ? 1 : parseFloat(window.Shopify.currency.rate);
        let compare_at = selectedVariant ? Number(selectedVariant.compare_at_price)*100 : (compareAtMap && compareAtMap[variant_id] !== price && compareAtMap[variant_id]);
        compare_at = window.mu_market_rounding ? Math.ceil(
            compare_at
            ): compare_at;
            if (!compare_at) return acc;
        if (window.mu_handle_compareAt) compare_at = window.mu_handle_compareAt(variant_id, quantity, price, compare_at);
        const discount = new Decimal(compare_at).minus(price).times(quantity).toNumber();
        return acc + discount;
    }, 0);
    return compareAtDiscount;
};

export function GetCartLineItemDiscount(item, checkAgainst = ['automatic', '']) {
    return item.line_level_discount_allocations?.filter(({ discount_application }) =>
            checkAgainst.includes(discount_application?.type)
        ).reduce((acc, { amount }) => acc + amount, 0);
}

export function FilterAtuGoals(goals, hasAutoDiscount) {
    return hasAutoDiscount ? goals.filter(({ reward_type }) => reward_type !== 'discount') : goals;
}

function itemHasAutoDiscount({ discounted_price, price }) {
    return discounted_price !== price;
}

export function GetPresentableItemsList(items) {
    const reversedItems = [...items].reverse();
 
    return reversedItems.reduce((acc, item, index) => {
        const line = items.length - index;
        const existingItemIndex = acc.findIndex(
            ({ variant_id, selling_plan_allocation, properties }) =>
                variant_id === item.variant_id &&
                selling_plan_allocation === item.selling_plan_allocation &&
                properties === item.properties
        );
        if (existingItemIndex === -1) {
            return acc.concat([{ ...item, line }]);
        }
        const existingItem = acc[existingItemIndex];
        // const oneItemIsAGift = [existingItem, item].some(isAutoDiscountGift)
        const oneItemHasADiscount = [existingItem, item].some(itemHasAutoDiscount);
        if (oneItemHasADiscount) {
            return acc.concat([{ ...item, line }]);
        }
        acc[existingItemIndex] = Object.assign({}, existingItem, {
            // price: existingItem.price + item.price,
            discounted_price: existingItem.discounted_price + item.discounted_price,
            quantity: existingItem.quantity + item.quantity,
            line_quantity: item.quantity,
            line
        });
        return acc;
    }, []);
}

export function getAutoDiscounts({items,cart_level_discount_applications = []}) {
        // look for automatic discounts
    const ItemLevelAutoDiscount = items.map(i => GetCartLineItemDiscount(i)).reduce((a, b) => a + b, 0);
    const CartLevelAutoDiscount = GetCartLevelAutoDiscount({cart_level_discount_applications}, ['automatic', ''])?.total_allocated_amount || 0;
    return {
        ItemLevelAutoDiscount,
        CartLevelAutoDiscount,
        totalAutoDiscount: ItemLevelAutoDiscount + CartLevelAutoDiscount
    }
}

export const getDiscount = ({
    campaigns,
    items,
    cart_level_discount_applications = [],
    total,
    filteredItems,
    filteredItemsTotal,
    discountCode,
    getBundlesOnly = false
}) => {
    // const ItemLevelTotalDiscount = discountCode?.value ? 0 : window.mu_use_new_discount_calculation ? items.map( i => GetCartLineItemDiscount(i, ['discount_code'])).reduce((a, b) => a + b, 0) : items.reduce((total, item) => {
    //   return total + (item.total_discount || 0);
    // }, 0);
    const ItemLevelTotalDiscount = window.mu_use_new_discount_calculation ? items.map( i => GetCartLineItemDiscount(i, ['discount_code'])).reduce((a, b) => a + b, 0) : items.reduce((total, item) => {
      return total + (item.total_discount || 0);
    }, 0);
    // const CartLevelDiscountCode = GetCartLevelAutoDiscount({cart_level_discount_applications}, ['discount_code'])?.totalAutoDiscount || discountCode?.value || 0;
    const CartLevelDiscountCode = GetCartLevelAutoDiscount({cart_level_discount_applications}, ['discount_code'])?.totalAutoDiscount || 0;
    // look for automatic discounts
    const { ItemLevelAutoDiscount, CartLevelAutoDiscount, totalAutoDiscount } = getAutoDiscounts({items,cart_level_discount_applications})

    const totalAppliedDiscounts = items.reduce((total, { discounts = [] }) => {
      return total + discounts.reduce((acc, discount) => acc + discount.amount, 0);
    }, 0);

    if(window.mu_use_totalAppliedDiscounts && totalAppliedDiscounts) return totalAppliedDiscounts;
    
    if ((CartLevelDiscountCode || ItemLevelTotalDiscount) && !totalAutoDiscount) {
        return CartLevelDiscountCode + ItemLevelTotalDiscount
    }
    else if (totalAutoDiscount)
        return totalAutoDiscount + (CartLevelDiscountCode || 0) + (window.mu_use_new_discount_calculation ? ItemLevelTotalDiscount || 0 : 0);
    if (!campaigns || !Object.keys(campaigns).length) return ItemLevelTotalDiscount;
    const calculatedCampaignsTypes = [];
    const countedBundles = []
    const bundlesDiscounts = [...items].reverse().reduce((acc, item) => {
        const { product_id } = item;
        const product_bundles_campaign = (campaigns[product_id] || []).find(
            ({ type }) => type === 'bundles'
        );

        if (product_bundles_campaign && !countedBundles.includes(product_id)) {
            countedBundles.push(product_id);
            const { bundles } = product_bundles_campaign;
            const productItems = items.filter(i => i.product_id === product_id);
            const quantity = productItems.reduce((acc, { quantity }) => acc + quantity, 0);
            const bundlesIndexMap = BundlesIndexMap(sortBundles(bundles.list));
            const maxQuantity = Math.max(...Object.keys(bundlesIndexMap).map(Number));
            let selectedBundle = bundlesIndexMap[quantity];

            if (selectedBundle === undefined && quantity > maxQuantity) {
                selectedBundle = bundlesIndexMap[maxQuantity];
            }

            const bundle = bundles.list[selectedBundle];
            if (!bundle) return acc;

            // New: apply discount per item with rounding
            const discountRate = bundle.reward / 100;
            const isPercentage = bundle.type === 'percentage';
            let bundleDiscount = 0;

            for (const item of productItems) {
                const itemTotal = item.price * item.quantity;

                let lineDiscount = 0;
                if (isPercentage) {
                    lineDiscount = Math.floor(item.price * discountRate) * item.quantity;
                } else {
                    lineDiscount = calculateReward(bundle, itemTotal);
                }
                bundleDiscount += lineDiscount;
            }

            acc += Math.round(bundleDiscount * 100) / 100;
        }

        return acc;
    }, 0);
    if (getBundlesOnly) return bundlesDiscounts;
    const [add_to_unlock_product_id, add_to_unlock] = getCampaign('add_to_unlock')(
        campaigns,
        items
    );
    let atuDiscount = 0;
    const totalWithBundlesDiscount = filteredItemsTotal - bundlesDiscounts;
    const quantityCount = filteredItems.reduce((acc, cur) => {
        return acc + Number(cur.quantity);
    }, 0);
    if (add_to_unlock && add_to_unlock?.isActive) {
        const discounts = add_to_unlock.goals.filter(
            ({ reward_type, goal: oldGoal, specific_goals }) => {
                const goal = getGoal({
                    oldGoal,
                    specific_goals,
                    byQuantity: add_to_unlock.multi_goal_type === 'quantity'
                });
                let unlocked = false;
                if (add_to_unlock.multi_goal_type === 'amount') {
                    unlocked = totalWithBundlesDiscount >= goal * 100;
                } else if (add_to_unlock.multi_goal_type === 'quantity') {
                    unlocked = quantityCount >= goal;
                }
                return reward_type === 'discount' && unlocked;
            }
        );
        atuDiscount = discounts.reduce((acc, cur) => {
            const add_to_unlock_discount = calculateReward(cur.discount, totalWithBundlesDiscount);
            if (add_to_unlock_discount > acc) {
                acc = add_to_unlock_discount;
            }
            return acc;
        }, 0);
    }
    return bundlesDiscounts + (window.round_atuDiscount
      ? Math.round(atuDiscount/100)*100
      : atuDiscount);
};

export const getModules = (campaign, cart_settings) => {
    return campaign ? campaign.settings.modules : cart_settings.modules;
};

const calculateReward = ({ type, reward }, total) => {
    return Math.floor(calculateDiscount({ reward, type, total }));
};

const percentage = (partialValue, totalValue) => {
    return Math.floor((totalValue / 100) * partialValue);
};

const lightOrDark = (color) => {
    color = formatColor(color);
    var r, g, b, hsp;
    if (color.match(/^rgb/)) {
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
    }
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    return hsp > 127.5 ? 'light' : 'dark';
};

export const formatColor = (color, alpha = null) =>
    !!color
        ? typeof color === 'string'
            ? color
            : `rgba(${color?.r},${color?.g},${color?.b},${alpha || color?.a})`
        : undefined;

export function formatColorHex(color) {
    const { r, g, b } = color;
    return rgbaToHex(r, g, b);
}

export function RGBToHex(r, g, b) {
    r = r.toString(16);
    g = g.toString(16);
    b = b.toString(16);

    if (r.length == 1) r = '0' + r;
    if (g.length == 1) g = '0' + g;
    if (b.length == 1) b = '0' + b;

    return '#' + r + g + b;
}
export const colorAutoBlend = (percentage, color) => {
    switch (lightOrDark(color)) {
        case 'light':
            return darkerColor(percentage, formatColor(color));
        case 'dark':
            return lighterColor(percentage, formatColor(color));
    }
};
export const lighterColor = (percentage, color, blend = '#fff') => {
    color = formatColor(color);
    return pSBC(percentage, color, blend, true);
};
export const darkerColor = (percentage, color, blend = '#000') => {
    color = formatColor(color);
    return pSBC(-percentage, color, blend, true);
};

export const fakePreviewProducts = (price = '20.00', index = 0) => [
    {
        isExample: true,
        handle: 'example-product',
        id: index.toString(),
        options: [
            {
                id: 0,
                product_id: index.toString(),
                name: 'Title',
                position: 1,
                values: ['Default Title']
            }
        ],
        images: [
            {
                src: 'https://cdn.pixabay.com/photo/2017/01/25/17/35/picture-2008484_1280.png'
            }
        ],
        title: 'Example product',
        variants: [
            {
                id: 1,
                product_id: index.toString(),
                image: null,
                price: price,
                featured_image: {
                    src: 'https://cdn.pixabay.com/photo/2017/01/25/17/35/picture-2008484_1280.png'
                },
                title: 'Default Title',
                quantity: 20,
                inventory_policy: 'continue',

                inventory_management: null,
                inventory_quantity: 1,
                old_inventory_quantity: 1
            }
        ],
        variant_id: 1
    }
];

export const em = (font_size) => `${font_size}em`;

export function hasParentWithMatchingSelector(target, selector) {
    return [...document.querySelectorAll(selector)].some(
        (el) => el !== target && el.contains(target)
    );
}

export async function getScriptStatus(shop, origin, callback) {
  try {
    const { data } = await Axios.get(
      `${API_GATEWAY_NEW}/storeFront?shop=${shop}&manual_setup=true&origin=${origin}`
    );
    let isScript =
      data.includes("/cart_renderer.gz.js") ||
      data.includes("/cart_renderer.js");
    return callback(isScript);
  } catch (error) {
    return callback(false, true);
  }
};

export async function getShopProducts() {
    try {
        if (window.mu_stop_json_products) return [];
        const totalPages = window.mu_get_all_products ? Number(window.mu_get_all_products) : 10; 
        const requests = [];

        // Create an array of requests for each page
        for (let page = 1; page <= totalPages; page++) {
            requests.push(
                Axios.get(getLangPath(`products.json?limit=250&page=${page}`))
            );
        }
        // Fetch all pages concurrently
        const responses = await Promise.all(requests);
        const products = responses.flatMap(
            (response) => response.data?.products ?? []
        );
        return products;
    } catch (error) {
        console.error("Error fetching multiple pages:", error);
        return [];
    }
};

const getRechargeSubscriptionsData = async (productId, isPreview) => {
  try {
    const response = await fetch(
      `https://static.rechargecdn.com/store/${
        isPreview ? "monsterapps-beta.myshopify.com" : window.Shopify.shop
      }/product/2022-06/${productId}.json`
    );
    if (!response.ok) {
      console.error("Failed to fetch Recharge subscription data");
      return null;
    }
    const data = await response.json();
    if (
      data &&
      data.product &&
      data.product.plans &&
      data.product.plans.length
    ) {
      const plans = data.product.plans;
      const groupedPlans = {
        onetime: [],
        subscriptions: {},
      };

      plans.reverse().forEach((plan) => {
        if (plan.type === "onetime") {
          groupedPlans.onetime.push(plan);
        } else if (plan.type === "subscription") {
          const discountLabel = `Subscribe and Save ${plan.discount_amount}%`;
          if (!groupedPlans.subscriptions[discountLabel]) {
            groupedPlans.subscriptions[discountLabel] = [];
          }
          groupedPlans.subscriptions[discountLabel].push(plan);
        }
      });
      return groupedPlans;
    }
    return null;
  } catch (error) {
    console.error("Error fetching recharge subscriptions data:", error);
    return null;
  }
};

export const getDefaultSubscriptionsData = async (productUrl, appId, variantId) => {
  try {
    const url = `https://${window.location.hostname}${productUrl?.split("?")[0]}.js`;

    const response = await fetch(url);

    if (!response.ok) {
      console.error("Failed to fetch subscriptions data");
      return null;
    }

    const data = await response.json();

    if (!data?.selling_plan_groups?.length) {
      return null;
    }

    const filteredSubscriptions = data.selling_plan_groups.filter(
      (group) =>
        (group.app_id &&
          group.app_id?.toLowerCase().includes(appId?.toLowerCase())) ||
        !appId
    );

    if (!filteredSubscriptions.length) {
      return null;
    }

    const selectedVariant = variantId
      ? data.variants.find((variant) => variant.id == variantId)
      : null;

    if(selectedVariant && !selectedVariant.selling_plan_allocations?.length) return null;

    const groupedPlans = {
      onetime: (
        selectedVariant
          ? selectedVariant.requires_selling_plan
          : data.requires_selling_plan
      )
        ? []
        : [
            {
              id: "onetime",
              type: "onetime",
              title: "One-time Purchase",
            },
          ],
      subscriptions: {},
      variants: data.variants,
      selling_plan_groups: data.selling_plan_groups,
    };

    filteredSubscriptions.forEach((subscriptionGroup) => {
      subscriptionGroup.selling_plans.forEach((plan) => {
        const { name, id, price_adjustments } = plan;
        const priceAdjustment = price_adjustments?.[0];

        let discount = "";
        if (priceAdjustment?.value) {
          if (priceAdjustment?.value_type === "percentage") {
            discount = `${priceAdjustment?.value}%`;
          } else if (priceAdjustment?.value_type === "price") {
            const oneTimePrice = selectedVariant
              ? selectedVariant.price
              : data.variants[0].price;
            const formattedMoney = formatMoney(
              oneTimePrice - priceAdjustment?.value,
              window.mu_money_format
            );
            discount = new DOMParser().parseFromString(
              formattedMoney,
              "text/html"
            ).body.textContent;
          } else {
            // Reintroducing DOMParser to strip any HTML tags from the formatted money string
            const formattedMoney = formatMoney(
              priceAdjustment?.value,
              window.mu_money_format
            );
            discount = new DOMParser().parseFromString(
              formattedMoney,
              "text/html"
            ).body.textContent;
          }
        }

        const discountLabel = discount
          ? `Subscribe & Save ${discount}` //`${subscriptionGroup.name} ${discount}`
          : "Subscribe without discount";

        const availableForVariant = selectedVariant
          ? selectedVariant.selling_plan_allocations.some(
              (spa) => spa.selling_plan_id == id
            )
          : true;
          
        if (availableForVariant) {
          if (!groupedPlans.subscriptions[discountLabel]) {
            groupedPlans.subscriptions[discountLabel] = [];
          }

          groupedPlans.subscriptions[discountLabel].push({
            id,
            external_plan_id: id,
            external_plan_name: name,
            charge_interval_frequency: 30,
            discount_amount: (priceAdjustment?.value_type === "percentage"
              ? priceAdjustment.value
              : (priceAdjustment?.value / 100 || 0).toFixed(2)
            )?.toString(),
            discount_type: priceAdjustment?.value_type,
            external_plan_group_id: subscriptionGroup.id,
            title: `${name}${discount ? ` with ${discount}` : ""}`,
            type: "subscription",
            //   apply_cutoff_date_to_checkout: false,
            //   charge_interval_frequency: 30,
            //   external_variant_ids: [],
            //   has_variant_restrictions: false,
            // interval_unit: "day",
            // order_interval_frequency: 30,
            //   pricing_progression: [],
            // sort_order: 2,
          });
        }
      });
    });

    return groupedPlans;
  } catch (error) {
    console.error("Error fetching subscriptions data:", error);
    return null;
  }
};

export const getPlansData = async (productId, appType, productUrl, isPreview, variantId) => {
  switch (appType) {
    case "recharge":
      return await getRechargeSubscriptionsData(productId, isPreview);
    case "seal":
      return await getDefaultSubscriptionsData(
        productUrl,
        "Seal Subscriptions",
        variantId
      );
    case "subify":
      return await getDefaultSubscriptionsData(productUrl, "subi", variantId);
    case "casa":
      return await getDefaultSubscriptionsData(
        productUrl,
        "IW00819979621610",
        variantId
      );
    case "appstle":
      return await getDefaultSubscriptionsData(
        productUrl,
        "appstle",
        variantId
      );
    case "recurpay":
      return await getDefaultSubscriptionsData(productUrl, null, variantId);
    case "yotpo":
      return await getDefaultSubscriptionsData(
        productUrl,
        "Yotpo Echo",
        variantId
      );
    case "paywhirl":
      return await getDefaultSubscriptionsData(
        productUrl,
        "paywhirl",
        variantId
      );
    case "bold":
      return await getDefaultSubscriptionsData(
        productUrl,
        "39301",
        variantId
      );
    default:
      return null;
  }
};